import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageDTO } from '../model/page-dto';
import { Router } from '@angular/router';
import { AlertDTO } from '../model/alerts/alert-dto';
import { CyberAttackDTO } from '../model/alerts/attacks/cyber-attack-dto';
import { CyberAttackManagementTypeEnum } from '../model/alerts/attacks/cyber-attack-management-type-enum';
import { CyberAttackTypeEnum } from '../model/alerts/attacks/cyber-attack-type-enum';

@Injectable({
    providedIn: 'root'
})
export class AlertService extends BaseService {

    constructor(http: HttpClient, router: Router) {
        super(http, router)
    }

    getAlerts(pageNumber: number, pageSize: number, nodeId?: number, from?: string, to?: string, managed?: boolean): Promise<PageDTO<AlertDTO>> {
        let parameters = new HttpParams()
            .set('pageNumber', pageNumber)
            .set('pageSize', pageSize)

        if (nodeId !== undefined) {
            parameters = parameters.set('nodeId', nodeId)
        }
        if (from !== undefined) {
            parameters = parameters.set('from', from)
        }
        if (to !== undefined) {
            parameters = parameters.set('to', to)
        }
        if (managed !== undefined) {
            parameters = parameters.set('managed', managed)
        }
        let request = this.get<PageDTO<AlertDTO>>("alerts", parameters);
        return this.apiCall<PageDTO<AlertDTO>>(request)
    }

    getManualAlerts(pageNumber: number, pageSize: number, from?: string, to?: string, managed?: boolean): Promise<PageDTO<AlertDTO>> {
        let parameters = new HttpParams()
            .set('pageNumber', pageNumber)
            .set('pageSize', pageSize)

        if (from !== undefined) {
            parameters = parameters.set('from', from)
        }
        if (to !== undefined) {
            parameters = parameters.set('to', to)
        }
        if (managed !== undefined) {
            parameters = parameters.set('managed', managed)
        }
        let request = this.get<PageDTO<AlertDTO>>("alerts/manual", parameters);
        return this.apiCall<PageDTO<AlertDTO>>(request)
    }

    public manageAttack(attack: CyberAttackDTO, managementType: CyberAttackManagementTypeEnum): Promise<void> {
        let parameters = new HttpParams().set('managementType', managementType)
        const request = this.post<void>(`alerts/attack/${attack.id}`, null, parameters)
        return this.apiCall<void>(request);
    }

    public unmanageAttack(attack: CyberAttackDTO, deleteAlert: boolean): Promise<void> {
        let parameters = new HttpParams().set('deleteAlert', deleteAlert);
        const request = this.delete<void>(`alerts/attack/${attack.id}`, parameters)
        return this.apiCall<void>(request);
    }

    public getAlert(id: number) {
        const request = this.get<AlertDTO>(`alerts/${id}`)
        return this.apiCall<AlertDTO>(request);
    }

    public createManualAlert(ip: string, type: CyberAttackTypeEnum): Promise<void> {
        let parameters = new HttpParams().set('ip', ip).set('type', type)
        const request = this.post<void>('alerts/manual-alert/block-ip', null, parameters)
        return this.apiCall<void>(request);
    }

}
